import React, {useRef, useEffect, useCallback} from 'react';

export const useNodeHistory = (selectedNodes) => {
    let nodeHistory = useRef([]);

    useEffect(() => {
        if (selectedNodes) {
            nodeHistory.current = [...nodeHistory.current, ... selectedNodes];
        }
    }, [selectedNodes]);

    return {
        getLastNode: (nodes) => {
            let hist = [...nodeHistory.current];
            hist.reverse();
            for (let n of hist) {
                if (nodes && !nodes.includes(n)) {
                    return n;
                }
            }
            return undefined;
        }
    };
};
